export const NOME = 'Nome';
export const TIPO_TELEFONE = 'Tipo Telefone';
export const DDD = 'DDD';
export const TELEFONE = 'Telefone';
export const OBSERVACAO = 'Observação';
export const WHATSAPP = 'WhatsApp';
